import { useContext } from "react";
import { ConfirmContext } from "./ConfirmContext";
import { TConfirmContextValue } from "./ConfirmContext.types";

export const useConfirm = (): TConfirmContextValue => {
  const context = useContext(ConfirmContext);

  if (context === undefined) {
    throw new Error("useConfirm must be used within an ConfirmProvider");
  }

  return context;
};
